import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import CONSTANTS from '../../_constants/constants';
import { environment } from '../../../environments/environment';
// import { DefaultParams } from '../../_shared/interfaces/defaultParams';

import { PaxRange } from './pax-range.model';

@Injectable({
  providedIn: 'root',
})
export class PaxRangeService {
  private apiUrl = environment.apiEndpoint + 'pax_ranges';

  constructor(private http: HttpClient) {}

  getFilterCriteria() {
    // const defaultParams: ExtendedDefaultParams = {
    const defaultParams = {
      page: 1,
      sortDir: 'asc',
      sortedBy: 'pax_from',
    };

    return defaultParams;
  }

  getPaxRanges(params = null): Observable<any> {
    const queryParams = new HttpParams({ fromObject: params });

    return this.http.get(this.apiUrl, { params: queryParams });
  }

  savePaxRange(paxRangeId: string, paxRange: PaxRange): Observable<PaxRange> {
    const body = {
      pax_range: paxRange,
      // lang: lang || CONSTANTS.DEFAULT_CONTENT_LANGUAGE,
    };

    if (!paxRangeId) {
      return this.http.post<PaxRange>(`${this.apiUrl}`, body);
    } else {
      return this.http.put<PaxRange>(`${this.apiUrl}/${paxRangeId}`, body);
    }
  }

  // Get the lowest pax range from the given array of pax ranges by pax_from
  getLowestPaxRange(array) {
    let lowest = array[0];

    array.forEach((item) => {
      if (item.pax_from < lowest.pax_from) {
        lowest = item;
      } else if (item.pax_from === lowest.pax_from) {
        // if item and lowest are equals use the pax_to for get the lowest
        if (item.pax_to < lowest.pax_to) {
          lowest = item;
        }
      }
    });

    return lowest;
  }
}
